import React, { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import {validateEmail} from '../helpers/common';



const Login = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [inputError, setInputError] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);

    const [inputData, setInputData] = useState({
        email: "",
    });
    useEffect(() => {

        document.title = 'Roam Pays: Login';

       
if(localStorage.getItem("@email-login-exists"))   {

    setErrorResponse(localStorage.getItem("@email-login-exists"));
    localStorage.removeItem("@email-login-exists");



}    
    
      }, []);
    const handleLogin = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(null);

        const { email } = inputData;
        if (!email || !validateEmail(email)) {
            setInputError(true);
            setIsBtn(false)
        } else {

            setInputError(false);
            await axios.post(process.env.REACT_APP_API_URL + "/login", {
                email: email,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {

                       
                            localStorage.setItem("@email", email)
                            navigate("/login-otp");

                        

                    } else {

                        setErrorResponse(response?.data?.message);
                        //Swal.fire({ icon: "error", title: "Login Failed", text: response?.data?.message, footer: '<a href="/forgot-password">Forgot Password</a>' });

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Login Failed", text: error.message });

                });

        }
    };

    return (


        <div class="form-container">

{errorResponse &&
                <div className="fs-14  color-white" role="alert">
                    {errorResponse}
                </div>
            }

            <h3 className="form-title color-white">Welcome Back</h3>
            
            <div className="input-text" >
                <label className="color-light fs-12">Email Address</label>

                <input type="text" className="color-light fs-14" id="email"
                    name="email" value={inputData.email}
                    onChange={(e) => setInputData({ ...inputData, email: e.target.value })}
                />

                {inputError && !inputData.email && (
                    <span className="color-white fs-10">This field is required</span>
                )}
                     {inputError && !validateEmail(inputData.email) && (
                    <span className="color-white fs-14">Invalid email address format</span>
                )}

           </div>
         

            <button type="button" onClick={handleLogin} className="button-purple fs-14 color-white" disabled={isBtn}>
                {isBtn ? <Loading size={'20px'} /> : 'Continue'}
            </button>
         


            <div className="content fs-12 color-white" >
                Don't have an account? <Link className="" to="/register">Sign Up</Link>
            </div>

         
          

        </div>


    );
};

export default Login;